import { tr } from '@/i18n';
/** 小型 DOM 建構工具：一律用 textContent，避免把內容當 HTML 注入 */
type Child = Node | string | null | undefined | false;
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Record<string, any> = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v == null || v === false) continue;
    if (k === 'class') el.className = v;
    else if (k === 'style' && typeof v === 'object') Object.assign(el.style, v);
    else if (k.startsWith('on') && typeof v === 'function') (el as any)[k.toLowerCase()] = v;
    else el.setAttribute(k, v === true ? '' : String(v));
  }
  for (const c of children) if (c != null && c !== false) el.append(c instanceof Node ? c : document.createTextNode(c));
  return el;
}
export const $ = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T;
export function clear(el: HTMLElement) { while (el.firstChild) el.removeChild(el.firstChild); }
export function modal(id: string, title: string, body: Node, onClose: () => void, wide = false): HTMLElement {
  document.getElementById(id)?.remove();
  const close = h('button', { class: 'icon-btn', type: 'button', 'aria-label': tr("關閉"), onclick: onClose }, '✕');
  const m = h('div', { class: 'modal', id, role: 'dialog', 'aria-modal': 'true', 'aria-label': title },
    h('div', { class: 'modal-card' + (wide ? ' wide' : '') }, h('div', { class: 'modal-head' }, h('h2', {}, title), close), h('div', { class: 'modal-body' }, body)));
  m.addEventListener('pointerdown', e => { if (e.target === m) onClose(); });
  document.getElementById('app')!.append(m);
  close.focus({ preventScroll: true });
  return m;
}
